/* ============================================================
   hg-cart-bundle.js — Hatgoods bundled cap in the cart
   assets/hg-cart-bundle.js
   ------------------------------------------------------------
   A custom cap is two cart lines: the cap and its patch. The
   patch line carries _showProduct=false, which this theme
   already honours, so it is hidden automatically.

   This script then does three things, entirely from JS, so no
   Liquid template needs editing:

     1. composites the patch onto the cap thumbnail, so the cart
        shows one finished cap
     2. shows the COMBINED price on the cap line, so the line
        total matches the cart total
     3. keeps the hidden patch quantity locked to its cap, and
        removes it when the cap is removed

   Row lookup uses the theme's own id scheme,
   CartDrawer-Item-{index+1}, which is stable on both the drawer
   and the cart page (cart-details renders the same section).
   ============================================================ */
(function () {
  'use strict';

  var syncing = false;
  var STYLE_ID = 'hg-bundle-style';

  /* ---------- styling for the composite thumbnail ---------- */

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      '.hg-bundle-wrap{position:relative;display:block;line-height:0;font-size:0;}' +
      '.hg-bundle-wrap .cart-item__image{display:block;width:100%;height:auto;}' +
      '.hg-bundle-patch{position:absolute;object-fit:contain;pointer-events:none;' +
      'filter:drop-shadow(0 1px 2px rgba(0,0,0,.35));}';
    document.head.appendChild(style);
  }

  /* ---------- money: copy the formatting already on the page ----------
     Rather than guess the currency format, read a price the theme has
     already rendered and rebuild it with the new number, keeping the same
     symbol, grouping and decimal places. */

  function formatLike(sample, cents) {
    var value = cents / 100;
    var match = String(sample).match(/[\d][\d.,\s\u00A0]*/);
    if (!match) return String(value);

    var token = match[0];
    var trimmed = token.trim();
    var decimals = /[.,]\d{2}$/.test(trimmed) ? 2 : 0;
    var groupSep = ',';
    var decSep = '.';

    if (decimals === 2) {
      decSep = trimmed.slice(-3, -2);
      groupSep = decSep === ',' ? '.' : ',';
    } else if (token.indexOf('.') > -1 && token.indexOf(',') === -1) {
      groupSep = '.';
    }

    var parts = value.toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, groupSep);
    var out = parts.length > 1 ? parts[0] + decSep + parts[1] : parts[0];

    return sample.replace(token, out);
  }

  /* Find the DOM row for a cart line. The theme's id scheme is the primary
     route, but rows can be re-indexed after a re-render, so fall back to the
     quantity input's variant id and finally to the thumbnail's image. */
  function findRow(item, index) {
    var byId = document.getElementById('CartDrawer-Item-' + (index + 1));
    if (byId && rowMatches(byId, item)) return byId;

    var byVariant = document.querySelector(
      '.cart-item [data-quantity-variant-id="' + item.variant_id + '"]'
    );
    if (byVariant) {
      var row = byVariant.closest('.cart-item, tr');
      if (row) return row;
    }

    if (byId) return byId;

    if (item.image) {
      var stem = String(item.image).split('?')[0].split('/').pop();
      var imgs = document.querySelectorAll('.cart-item__image');
      for (var i = 0; i < imgs.length; i++) {
        if (String(imgs[i].getAttribute('src') || '').indexOf(stem) > -1) {
          return imgs[i].closest('.cart-item, tr');
        }
      }
    }
    return null;
  }

  function rowMatches(row, item) {
    var qty = row.querySelector('[data-quantity-variant-id]');
    if (!qty) return true;
    return String(qty.getAttribute('data-quantity-variant-id')) === String(item.variant_id);
  }

  /* Find the text node holding a given amount and rewrite it in place. */
  function replacePrice(container, oldCents, newCents) {
    if (!container || !oldCents) return false;
    var walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null, false);
    var node;
    while ((node = walker.nextNode())) {
      var text = node.nodeValue;
      if (!/\d/.test(text)) continue;
      var numeric = text.replace(/[^\d.,]/g, '').replace(/,/g, '');
      var value = parseFloat(numeric);
      if (isNaN(value)) continue;
      if (Math.round(value * 100) === oldCents) {
        node.nodeValue = formatLike(text, newCents);
        return true;
      }
    }
    return false;
  }

  /* ---------- 1 + 2. composite image and combined price ---------- */

  function decorate() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        injectStyle();

        cart.items.forEach(function (item, i) {
          var props = item.properties || {};
          if (!props._hg_patch_img) return;

          var row = findRow(item, i);
          if (!row) return;

          var stamp = props._hg_patch_img + '|' + item.quantity;
          if (row.dataset.hgStamp === stamp) return;

          // -- composite thumbnail --
          var media = row.querySelector('.cart-item__media');
          var capImg = media && media.querySelector('.cart-item__image');
          if (media && capImg) {
            // The percentages are relative to the cap PHOTO. The media cell is
            // usually taller/wider than the photo, so anchoring to the cell
            // pushes the patch off. Wrap the image and anchor to that instead.
            var wrap = media.querySelector('.hg-bundle-wrap');
            if (!wrap) {
              wrap = document.createElement('span');
              wrap.className = 'hg-bundle-wrap';
              capImg.parentNode.insertBefore(wrap, capImg);
              wrap.appendChild(capImg);
            }

            var slot = String(props._hg_slot || '34,26,32,30').split(',');
            var overlay = wrap.querySelector('.hg-bundle-patch');
            if (!overlay) {
              overlay = document.createElement('img');
              overlay.className = 'hg-bundle-patch';
              overlay.alt = '';
              overlay.loading = 'lazy';
              wrap.appendChild(overlay);
            }
            overlay.src = props._hg_patch_img;
            overlay.style.left = (parseFloat(slot[0]) || 34) + '%';
            overlay.style.top = (parseFloat(slot[1]) || 26) + '%';
            overlay.style.width = (parseFloat(slot[2]) || 32) + '%';
            overlay.style.height = (parseFloat(slot[3]) || 30) + '%';
          }

          // -- combined price --
          var extra = parseInt(props._hg_extra, 10) || 0;
          if (extra) {
            var details = row.querySelector('.cart-item__details') || row;
            var unitCents = item.final_price + extra;

            // In the plain (non-discounted) branch this theme prints the price
            // as a bare text node with no wrapping element, so there is nothing
            // to select. Walk the text nodes and match on the value instead.
            replacePrice(details, item.final_price, unitCents) ||
              replacePrice(details, item.original_price, unitCents);
          }

          row.dataset.hgStamp = stamp;
        });

        return cart;
      })
      .catch(function () { return null; });
  }

  /* ---------- 3. quantity and removal sync ---------- */

  function syncBundles() {
    if (syncing) return Promise.resolve();
    syncing = true;

    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var caps = {};
        var patches = [];

        cart.items.forEach(function (item) {
          var props = item.properties || {};
          if (!props._hg_bundle) return;
          if (props._hg_role === 'cap') caps[props._hg_bundle] = item.quantity;
          if (props._hg_role === 'patch') patches.push(item);
        });

        if (!patches.length) return null;

        var updates = {};
        patches.forEach(function (patch) {
          var want = caps[patch.properties._hg_bundle];
          if (want === undefined) updates[patch.key] = 0;
          else if (want !== patch.quantity) updates[patch.key] = want;
        });

        if (!Object.keys(updates).length) return null;

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (r) { return r.json(); });
      })
      .then(function (result) {
        syncing = false;
        if (result) refreshCartUI();
        return result;
      })
      .catch(function () { syncing = false; });
  }

  /* Re-render the drawer the way the theme does, so a sync shows at once. */
  function refreshCartUI() {
    var drawer = document.querySelector('cart-drawer');
    var id = window.Debutify && window.Debutify.cart_drawer_id;
    if (!drawer || !id) return;

    fetch('/cart?sections=' + encodeURIComponent(id) + ',cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var parser = new DOMParser();
        if (data[id]) {
          var doc = parser.parseFromString(data[id], 'text/html');
          var newInner = doc.querySelector('.drawer__inner');
          var oldInner = drawer.querySelector('.drawer__inner');
          if (newInner && oldInner) oldInner.innerHTML = newInner.innerHTML;
        }
        if (data['cart-icon-bubble']) {
          var bDoc = parser.parseFromString(data['cart-icon-bubble'], 'text/html');
          var newBubble = bDoc.querySelector('.shopify-section');
          var oldBubble = document.getElementById('cart-icon-bubble');
          if (newBubble && oldBubble) oldBubble.innerHTML = newBubble.innerHTML;
        }
        decorate();
      })
      .catch(function () {});
  }

  /* ---------- wiring ---------- */

  function boot() {
    decorate();
    syncBundles();
    // the drawer paints its contents asynchronously after an add, so look
    // again a couple of times rather than only once
    setTimeout(decorate, 400);
    setTimeout(decorate, 1200);
  }

  var observer = new MutationObserver(function () {
    clearTimeout(observer._paint);
    observer._paint = setTimeout(decorate, 80);
    clearTimeout(observer._sync);
    observer._sync = setTimeout(syncBundles, 500);
  });

  function watch() {
    document.querySelectorAll('cart-drawer, cart-details, .cart-items').forEach(function (t) {
      observer.observe(t, { childList: true, subtree: true });
    });
  }

  function start() { boot(); watch(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  document.addEventListener('cart:refresh', function () { setTimeout(boot, 300); });
  document.addEventListener('cart:updated', function () { setTimeout(boot, 300); });

  window.HGCartBundle = { decorate: decorate, sync: syncBundles };
})();